import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import NotFound from './pages/NotFound'
import Chat from './pages/Chat'
import Browser from './pages/Browser'
import BrowserEntry from './pages/BrowserEntry'
import SimpleSearch from './pages/SimpleSearch'
import SimpleSearchEntry from './pages/SimpleSearchEntry'
import RecommendationsTest from './pages/RecommendationsTest'
import DemoProducts from './pages/DemoProducts'
import Guide from './pages/Guide'
import './App.css'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/browser/entry" element={<BrowserEntry />} />
          <Route path="/browser" element={<Browser />} />
          <Route path="/simple-search/entry" element={<SimpleSearchEntry />} />
          <Route path="/simple-search" element={<SimpleSearch />} />
          <Route path="/recommendations-test" element={<RecommendationsTest />} />
          <Route path="/demo/products" element={<DemoProducts />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
